module.exports = __webpack_public_path__ + "static/media/Kravi_hora_Konice.6ad28929.md";